import React from 'react';
import { Card } from "react-bootstrap";
import face_image from "../../assets/img/faceBalintDaroczy.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projDaroczyB_transformer.png";

const Balint_Daroczy_transformer = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_image}
              /* this will be the text on the banner */
              alt="Generalization Bounds for Transformer Architectures via Rademacher Contraction"
            />{" "}
            <p className="text7">Bálint Daróczy </p>
            <br />
            <p className="text8">
              Senior Research Fellow{" "}
            </p>
            <p className="text8">SZTAKI, HUN-REN</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>

            Transformers achieve strong empirical performance, but theoretical generalization guarantees remain 
            challenging—especially because self-attention mixes tokens using data-dependent weights, so standard 
            contraction-style arguments are not directly applicable when the “nonlinearity” is itself parameterized. 
            During this project, we extend the notion of Rademacher Contraction (RC)—a parameter-aware contraction 
            framework used to control Rademacher complexity under composition—to self-attention-type layers, and use 
            it to derive generalization bounds for Transformer models. The first goal is to formalize self-attention 
            as an operator between suitable normed spaces and prove an RC inequality for a class of attention layers 
            under natural stability and norm constraints (e.g., bounded projection matrices and controlled 
            attention/operator norms). Building on the composition properties of RC, we then propagate these bounds 
            through multi-layer Transformer stacks (including residual connections and feedforward blocks) to obtain 
            end-to-end bounds on the model’s Rademacher complexity and hence the generalization gap. An important 
            outcome is to identify which architectural or regularity conditions (normalization, operator-norm control, 
            attention stability) lead to the cleanest bounds; depending on the assumptions, this analysis may also 
            suggest regimes where the dependence on sequence length can be improved, though whether it becomes fully 
            length-independent is part of what the project aims to clarify. Additionally, we may justify empirically 
            these dependencies on various datasets in case of small tabular and/or traditional transformer models, 
            even though non vacuous bound based analysis are yet to be confirmed.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balint_Daroczy_transformer;